import { ButtonBase } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Colors } from "styles/Colors";
import { getDiscordUrl, getGoogleUrl, getRedditUrl } from "./api";
import { useAuthStyles } from "./styles";

const PROVIDERS = [
	{
		id: "discord",
		label: "Discord",
		logo: "/images/DiscordLogo.png",
		imgSize: 32,
		surface: Colors.panelLight,
		getUrl: getDiscordUrl,
	},
	{
		id: "google",
		label: "Google",
		logo: "/images/GoogleLogo.png",
		imgSize: 68,
		getUrl: getGoogleUrl,
	},
	{
		id: "reddit",
		label: "Reddit",
		logo: "/images/RedditLogo.png",
		imgSize: 44,
		getUrl: getRedditUrl,
	},
];

export default function OAuthProviderRow({ label }) {
	const styles = useAuthStyles();
	const [urls, setUrls] = useState({});

	useEffect(() => {
		let active = true;

		Promise.all(
			PROVIDERS.map((provider) =>
				provider
					.getUrl()
					.then((url) => [provider.id, url])
					.catch(() => [provider.id, null])
			)
		).then((entries) => {
			if (!active) {
				return;
			}

			const resolved = {};
			entries.forEach(([id, url]) => {
				resolved[id] = url;
			});
			setUrls(resolved);
		});

		return () => {
			active = false;
		};
	}, []);

	return (
		<>
			<div className={styles.rule}>{label}</div>
			<div className={styles.providers}>
				{PROVIDERS.map((provider) => (
					<ButtonBase
						key={provider.id}
						className={styles.chip}
						style={{ backgroundColor: provider.surface }}
						aria-label={`Continue with ${provider.label}`}
						disabled={!urls[provider.id]}
						onClick={() => window.location.replace(urls[provider.id])}
					>
						<img
							src={provider.logo}
							alt=""
							style={{ width: provider.imgSize, height: provider.imgSize }}
						/>
					</ButtonBase>
				))}
			</div>
		</>
	);
}
